<section fxLayout="column" fxLayoutAlign="start center" class="main-container">
  <app-banner [text]="message"></app-banner>
  <app-result-viewer [passed]="passed" class="result-comp"></app-result-viewer>
</section>
